import { computed } from 'vue';
import { useAuthStore } from '@/store/auth';

export function useCurrentEmployee() {
  const authStore = useAuthStore();

  const employeeId = computed(() => authStore.user?.username || '');
  const employeeName = computed(
    () => authStore.user?.displayName || authStore.user?.username || '',
  );

  return { employeeId, employeeName };
}
